import { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { useLexicalTextEntity } from '@lexical/react/useLexicalTextEntity'
import { foldersByIdSelector } from 'selectors/folders/foldersByIdSelector'
import { queryIdToQuery } from 'ducks/searches/utils/query'
import { FilterNode, $createFilterNode } from './FilterNode'
import { getFilterMatchForQuery } from '../util'

const FilterPlugin = () => {
  const [editor] = useLexicalComposerContext()
  const foldersById = useSelector(foldersByIdSelector)

  useEffect(
    () => {
      if (!editor.hasNodes([FilterNode])) {
        throw new Error('FilterPlugin: FilterNode not registered on editor')
      }
    },
    [editor]
  )

  // If we have a folder search e.g. `folder:1464931230` we show the name of the
  // folder instead of the id.
  useEffect(
    () => {
      return editor.registerNodeTransform(FilterNode, filterNode => {
        const text = filterNode.getTextContent()
        const query = queryIdToQuery(text)
        const folderId = query?.folderId
        if (!folderId) return
        const name = foldersById[folderId]?.name
        if (!name) return
        filterNode.setTextContent(`folder:"${name}"`)
        filterNode.select()
      })
    },
    [editor, foldersById]
  )

  const createFilterNode = useCallback(textNode => {
    return $createFilterNode(textNode.getTextContent())
  }, [])

  const getFilterMatch = useCallback(text => {
    const matchArr = getFilterMatchForQuery(text)
    if (matchArr === null) {
      return null
    }
    return {
      end: matchArr.index + matchArr[0].length,
      start: matchArr.index,
    }
  }, [])

  useLexicalTextEntity(getFilterMatch, FilterNode, createFilterNode)

  return null
}

export default FilterPlugin
